// components/Footer.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import custom from "../../assets/dashboard/custom.svg";

const Footer = () => {
  const location = useLocation();
  const isDashboardPage = location.pathname === "/dashboard";

  return (
    <footer className="bg-gradient-01 p-4 text-lg text-black-600 border-t border-gray-200 md:ml-[123px] flex justify-between items-center">
      <div className="flex flex-col">
        <p className="font-bold">© Feelim 2026</p>
        <p className="text-xs">All rights reserved.</p>
      </div>
      {isDashboardPage && (
        <div className="flex items-center space-x-4">
          <button className="group flex items-center px-4 py-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 active:bg-black-800 active:text-black-0 border-2 border-black-800 rounded text-lg font-bold text-black-700 transition-colors duration-200 space-x-1">
            <img
              src={custom}
              alt="custom"
              className="transition duration-200 group-active:filter group-active:invert group-active:brightness-0 group-active:contrast-100"
            />
            <span>Customize</span>
          </button>
        </div>
      )}
    </footer>
  );
};

export default Footer;
